import { KEYBOARD } from 'modules/constants';
import { useTabManager } from './useTabManager';
export function useTabProps(tabId) {
    const { setActiveTab, activeTab, navigateToNextTab, navigateToPreviousTab, tabGroupId } = useTabManager();
    const isActive = activeTab === tabId;
    const htmlId = `${tabGroupId}-${tabId}`;
    const tabIndex = isActive ? 0 : -1;
    const handleClick = () => {
        setActiveTab(tabId);
    };
    const handleKeyDown = (e) => {
        if (!isActive) {
            return;
        }
        if (e.key === KEYBOARD.ARROW_RIGHT) {
            e.preventDefault();
            navigateToNextTab();
        }
        else if (e.key === KEYBOARD.ARROW_LEFT) {
            e.preventDefault();
            navigateToPreviousTab();
        }
    };
    const tabProps = {
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        tabIndex,
        role: 'tab',
        id: htmlId,
        'data-tab-id': tabId,
    };
    return { tabProps };
}
